import * as React from "react";

const SvgAdd = ({ ...props }) => {

    return (
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
     width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000"
     preserveAspectRatio="xMidYMid meet"
     {...props}
     >
    
    <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
    fill="currentColor" stroke="none">
    <path d="M1140 5113 c-190 -21 -408 -101 -565 -206 -83 -56 -108 -77 -203
    -170 -172 -169 -293 -394 -348 -647 -18 -81 -19 -156 -19 -1530 0 -1374 1
    -1449 19 -1530 113 -515 491 -893 1006 -1006 81 -18 156 -19 1530 -19 1374 0
    1449 1 1530 19 515 113 893 491 1006 1006 18 81 19 156 19 1530 0 1374 -1
    1449 -19 1530 -100 458 -422 823 -851 963 -198 65 -78 61 -1645 62 -784 1
    -1441 0 -1460 -2z m2870 -437 c94 -20 215 -69 289 -118 194 -127 339 -342 380
    -563 8 -40 11 -490 11 -1439 0 -1137 -3 -1393 -14 -1446 -33 -156 -117 -312
    -229 -428 -113 -116 -300 -215 -459 -242 -44 -7 -496 -10 -1468 -8 l-1405 3
    -95 33 c-132 46 -239 112 -335 207 -128 126 -205 265 -241 435 -20 97 -20
    2803 0 2900 71 333 328 592 661 665 91 20 2811 21 2905 1z"/>
    <path d="M2480 3824 c-42 -18 -86 -58 -108 -99 -15 -26 -18 -86 -22 -490 l-5
    -460 -460 -5 c-503 -5 -487 -3 -547 -67 -76 -80 -76 -206 0 -286 60 -64 44
    -62 547 -67 l460 -5 5 -460 c5 -503 3 -487 67 -547 80 -76 206 -76 286 0 64
    60 62 44 67 547 l5 460 460 5 c503 5 487 3 547 67 76 80 76 206 0 286 -60 64
    -44 62 -547 67 l-460 5 -5 460 c-5 503 -3 487 -67 547 -58 56 -151 73 -223 42z"/>
    </g>
    </svg>)
};

export default SvgAdd;